import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DrawerModule } from 'primeng/drawer';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { RippleModule } from 'primeng/ripple';
import { AvatarModule } from 'primeng/avatar';
import { MenuItem } from 'primeng/api';
import { DashboardSidebarComponent } from '../sidebar/dashboard-sidebar.component';
import { DashboardTopbarComponent } from '../topbar/dashboard-topbar.component';

@Component({
  standalone: true,
  selector: 'app-dashboard-layout',
  templateUrl: './dashboard-layout.component.html',
  styleUrl: './dashboard-layout.component.scss',
  imports: [
    CommonModule,
    RouterModule,
    DrawerModule,
    ButtonModule,
    MenuModule,
    RippleModule,
    AvatarModule,
    DashboardSidebarComponent,
    DashboardTopbarComponent
  ]
})
export class DashboardLayoutComponent implements OnInit {
  @ViewChild('sidebarRef') sidebarRef!: ElementRef;

  sidebarVisible: boolean = false;
  isMobile: boolean = false;

  ngOnInit() {
    this.checkScreenSize();
    window.addEventListener('resize', () => this.checkScreenSize());
  }

  private checkScreenSize(): void {
    this.isMobile = window.innerWidth < 992;
    if (!this.isMobile) {
      this.sidebarVisible = false;
    }
  }

  toggleSidebar(): void {
    this.sidebarVisible = !this.sidebarVisible;
  }

  onSidebarHide(): void {
    this.sidebarVisible = false;
  }
}
